import { render } from "./TheAside.vue?vue&type=template&id=50b57946&ts=true"
import script from "./TheAside.vue?vue&type=script&lang=ts"
export * from "./TheAside.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__